import actionTypes from '../../action-types'

export default (payload) => ({
  type: actionTypes.CUSTOMER_PRODUCTS.FETCH_ALL,
  payload,
})
